/*
 * @Author: zhaozhuo
 * @Date: 2022-02-23 14:07:53
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-02-23 14:07:53
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\filters\index.js
 */
// get dictionary的label
export function filterListLabel(value = '', dictionary = [], valueKey = 'value', labelKey = 'label') {
	const info =	dictionary.find(item => { return item[valueKey] === value })
	return info ? info[labelKey] : ''
}
// get dictionary的tem
export function filterListItem(value = '', dictionary = [], valueKey = 'value') {
	const info =	dictionary.find(item => { return item[valueKey] === value })
	return info || {}
}
// 获取特别类型date
export function filterSubstringDate(date) {
	return date ? date.substring(0, 10).replace(/-/g, '/') : ''
}